"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimateNumber = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var big_interpolate_1 = require("@terra-dev/big-interpolate");
var big_js_1 = __importDefault(require("big.js"));
var d3_ease_1 = require("d3-ease");
var d3_timer_1 = require("d3-timer");
var react_1 = require("react");
var defaultInitialValue = big_js_1.default(0);
function AnimateNumber(_a) {
    var children = _a.children, format = _a.format, _b = _a.initialValue, initialValue = _b === void 0 ? defaultInitialValue : _b, _c = _a.ease, ease = _c === void 0 ? d3_ease_1.easeCircleOut : _c, _d = _a.duration, duration = _d === void 0 ? 400 : _d, id = _a.id, spanProps = __rest(_a, ["children", "format", "initialValue", "ease", "duration", "id"]);
    var _element = react_1.useRef(null);
    var _format = react_1.useRef(format);
    var _value = react_1.useRef(initialValue);
    var _ease = react_1.useRef(ease);
    var _duration = react_1.useRef(duration);
    var value = react_1.useMemo(function () { return big_js_1.default(children).toFixed(); }, [children]);
    react_1.useEffect(function () {
        _format.current = format;
        if (_element.current) {
            _element.current.textContent = _format.current(_value.current);
        }
    }, [format]);
    react_1.useEffect(function () {
        _ease.current = ease;
    }, [ease]);
    react_1.useEffect(function () {
        _duration.current = duration;
    }, [duration]);
    react_1.useEffect(function () {
        if (!_element.current)
            return;
        var interpolate = big_interpolate_1.interpolateBig({
            from: _value.current,
            to: value,
            ease: _ease.current,
        });
        var ti = d3_timer_1.timer(function (elapsed) {
            var dv = interpolate(Math.min(elapsed / _duration.current, 1));
            _element.current.textContent = _format.current(dv);
            if (elapsed > _duration.current) {
                ti.stop();
                _element.current.textContent = _format.current(value);
            }
        });
        _value.current = big_js_1.default(value);
        return function () {
            ti.stop();
        };
    }, [value]);
    return (jsx_runtime_1.jsx("span", __assign({ ref: _element }, spanProps, { children: format(value) }), void 0));
}
exports.AnimateNumber = AnimateNumber;
//# sourceMappingURL=AnimateNumber.js.map